import type { ConstValues } from '@openx/types/helpers.ts';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
export const PACKAGE_LIST_TABS = {
  ALL: 'all',
  CURATED: 'curated',
} as const;

export type PackageListTabs = ConstValues<typeof PACKAGE_LIST_TABS>;

const getTabFromPath = (pathname: string) => {
  const pathPart = pathname.split('/').pop() ?? '';

  return pathPart === PACKAGE_LIST_TABS.CURATED ? PACKAGE_LIST_TABS.CURATED : PACKAGE_LIST_TABS.ALL;
};

export const usePackageListTabs = (pathname: string, showCuratedTabPermission: boolean) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<PackageListTabs>(getTabFromPath(pathname));

  const curatedPath = '/inventory/packages/curated';
  const pckgPath = '/inventory/packages';

  useEffect(() => {
    const tabFromPath = getTabFromPath(pathname);

    if (tabFromPath !== activeTab) {
      setActiveTab(tabFromPath);
    }
  }, [activeTab, pathname]);

  useEffect(() => {
    if (getTabFromPath(pathname) === PACKAGE_LIST_TABS.CURATED && !showCuratedTabPermission) {
      navigate(pckgPath);
    }
  }, [showCuratedTabPermission, navigate, pathname]);

  const changeTab = useCallback(
    (_, newTab) => {
      if (newTab === activeTab || !Object.values(PACKAGE_LIST_TABS).includes(newTab as PackageListTabs)) {
        return;
      }

      if (newTab === PACKAGE_LIST_TABS.CURATED) {
        navigate(curatedPath);
        return;
      }

      navigate(pckgPath);
    },
    [activeTab, navigate]
  );

  return {
    activeTab,
    changeTab,
  };
};
